import Vue from "vue"
import Vuex from "vuex"

import schoolsModule from "./modules/schools"
import essentialsModule from "./modules/essentials"
import staffModule from "./modules/contacts"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    schoolsModule,
    essentialsModule,
    staffModule
  },
  state: {
    isLoading: false
  },
  getters: {
    isLoading: state => state.isLoading
  },
  mutations: {
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
  }
})
